// src/data/content.js

import { UserCheck, Car, Ticket, FileText, Briefcase, GraduationCap, Home, Zap, Heart, Globe, TrendingUp } from 'lucide-react';

export const content = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About Us',
      contact: 'Contact',
      blogs: 'Blogs'
    },
    hero: {
      title: 'Aaple Sarkar E-Seva Kendra',
      subtitle: 'Your One-Stop Solution for All Government & Online Services',
      description: 'We provide complete assistance for government forms, online registrations, document services, and much more. Fast, reliable, and affordable services at your doorstep.',
      cta: 'View Services',
      cta2: 'Contact Us'
    },
    mainServices: {
      title: "Popular Service Categories",
      subtitle: "Quick access to our most requested documentation services",
      categories: [
        {
          id: 1,
          icon: "Briefcase",
          title: "Business Startup Documents",
          gradient: "linear-gradient(135deg, rgb(208 216 249) 0%, rgb(118, 75, 162) 100%)",
          iconColor: "#667eea",
          items: [
            "Shop Act License (Gumasta)",
            "Udyam Registration",
            "FSSAI License",
            "Rent Agreement Registration",
            "Proprietorship",
            "Partnership Firm",
            "LLP Firm",
            "Private Limited Company"
          ]
        },
        {
          id: 2,
          icon: "TrendingUp",
          title: "Business Promotion Documents",
          gradient: "linear-gradient(135deg, rgb(251 221 255) 0%, rgb(245, 87, 108) 100%)",
          iconColor: "#f5576c",
          items: [
            "Trademark Registration",
            "Website Design",
            "ISO Certification"
          ]
        },
        {
          id: 3,
          icon: "GraduationCap",
          title: "Educational Documents",
          gradient: "linear-gradient(135deg, rgb(219 238 255) 0%, rgb(0 106 254) 100%)",
          iconColor: "#4facfe",
          items: [
            "Domicile Certificate",
            "Income Certificate"
          ]
        },
        {
          id: 4,
          icon: "FileText",
          title: "Personal KYC Documents",
          gradient: "linear-gradient(135deg, rgb(234 255 241) 0%, rgb(56, 249, 215) 100%)",
          iconColor: "#43e97b",
          items: [
            "Passport",
            "Driving License",
            "Gazette Notification",
            "MSEB Name Change",
            "Vehicle Insurance",
            "PAN Card"
          ]
        }
      ]
    },
    services: {
      title: 'Our Complete Services',
      subtitle: 'Everything You Need Under One Roof',
      categories: [
        {
          name: 'ID & Documents',
          icon: 'UserCheck',
          services: [
            'Aadhar Card - Update/Correction',
            'PAN Card - New Application',
            'PAN Card - Correction/Reprint',
            'Ration Card Application',
            'Voter ID Card',
            'Passport Application & Renewal',
            'Income Certificate',
            'Domicile Certificate',
            'Caste Certificate'
          ]
        },
        {
          name: 'Vehicle Services',
          icon: 'Car',
          services: [
            'Learning License Application',
            'Driving License - New',
            'Driving License - Renewal',
            'RC Transfer',
            'Vehicle Registration',
            'Duplicate RC',
            'NOC for Vehicle',
            'Vehicle Insurance',
            'Pollution Certificate',
            'Fitness Certificate',
            'Fancy Number Application'
          ]
        },
        {
          name: 'Travel & Booking',
          icon: 'Ticket',
          services: [
            'Railway Ticket Booking (IRCTC)',
            'Tatkal Ticket Booking',
            'Flight Ticket Booking',
            'Bus Ticket Booking (MSRTC)',
            'Hotel Booking',
            'Travel Insurance'
          ]
        },
        {
          name: 'Government Forms',
          icon: 'FileText',
          services: [
            'Income Tax Return Filing',
            'GST Registration',
            'GST Return Filing',
            'FSSAI License',
            'Shop Act License',
            'Property Tax Payment',
            'Electricity Bill Payment',
            'Water Bill Payment',
            'Ration Card Form',
            'Senior Citizen Card'
          ]
        },
        {
          name: 'Employment Services',
          icon: 'Briefcase',
          services: [
            'PF Registration',
            'PF Withdrawal',
            'PF Transfer',
            'ESI Registration',
            'ESI Claim',
            'Labour Card Registration',
            'Unemployment Allowance',
            'Employment Registration',
            'Rojgar Melava Registration'
          ]
        },
        {
          name: 'Education Services',
          icon: 'GraduationCap',
          services: [
            'Scholarship Application',
            'School Admission Forms',
            'College Admission Forms',
            'Exam Form Filling',
            'Education Loan Application',
            'Certificate Verification',
            'Migration Certificate',
            'Bonafide Certificate'
          ]
        },
        {
          name: 'Property Services',
          icon: 'Home',
          services: [
            '7/12 Extract',
            '8A Extract',
            'Property Registration',
            'Property Tax',
            'Mutation Entry',
            'Property Search',
            'Land Record',
            'NOC for Construction'
          ]
        },
        {
          name: 'Utility & Bills',
          icon: 'Zap',
          services: [
            'Electricity Bill Payment',
            'MSEB New Connection',
            'Water Bill Payment',
            'Gas Bill Payment',
            'Mobile Recharge',
            'DTH Recharge',
            'Broadband Bill Payment',
            'Credit Card Bill Payment',
            'Insurance Premium Payment'
          ]
        },
        {
          name: 'Social Welfare',
          icon: 'Heart',
          services: [
            'Widow Pension',
            'Old Age Pension',
            'Disability Pension',
            'Annapurna Yojana',
            'Sanjay Gandhi Niradhar Yojana',
            'Shravan Bal Seva Yojana',
            'Handicap Certificate',
            'Marriage Certificate'
          ]
        },
        {
          name: 'Other Services',
          icon: 'Globe',
          services: [
            'Online Form Filling',
            'Xerox & Printing',
            'Scanning Services',
            'Lamination',
            'Passport Size Photo',
            'Computer Training',
            'Digital Signature',
            'Email ID Creation',
            'Resume Making',
            'Notary Services'
          ]
        }
      ]
    },
    why: {
      title: 'Why Choose Us?',
      points: [
        {
          title: 'Fast and reliable service',
          detail: 'We complete most services within 24-48 hours. Our efficient process ensures you get your documents and services without unnecessary delays.'
        },
        {
          title: 'Experienced staff',
          detail: 'Our team has 10+ years of experience in government documentation and online services. We know the process inside-out and guide you at every step.'
        },
        {
          title: 'Affordable pricing',
          detail: 'Transparent and competitive pricing with no hidden charges. We believe in fair rates that everyone can afford without compromising on quality.'
        },
        {
          title: 'All services under one roof',
          detail: 'From Aadhar to passport, PAN to vehicle registration - get everything done at one place. Save time and effort with our comprehensive service range.'
        },
        {
          title: 'Proper documentation support',
          detail: 'We help you prepare all required documents correctly. Our checklist ensures nothing is missing, avoiding rejection and saving your precious time.'
        },
        {
          title: 'Customer Privacy Assurance',
          detail: 'We prioritize the confidentiality of your documents and ensure that all your information is kept secure throughout the process. Rest assured, your documents are handled with the utmost care and privacy.'
        }
      ]
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Trusted by thousands of satisfied customers',
      testimonials: [
        {
          name: 'Rajesh Kumar',
          service: 'PAN Card Service',
          rating: 5,
          text: 'Excellent service! Got my PAN card within a week. The staff was very helpful and guided me through the entire process. Highly recommended!',
          location: 'Thane West'
        },
        {
          name: 'Priya Sharma',
          service: 'Passport Application',
          rating: 5,
          text: 'Very professional and efficient. They helped me with my passport application and I received it without any hassle. Great experience!',
          location: 'Kalwa'
        },
        {
          name: 'Amit Patil',
          service: 'Driving License',
          rating: 5,
          text: 'Fast and reliable service. Got my driving license renewed quickly. The pricing was also very reasonable. Will definitely come back for other services.',
          location: 'Mumbra'
        },
        {
          name: 'Sneha Desai',
          service: 'Aadhar Card Update',
          rating: 5,
          text: 'Very helpful staff! They corrected my Aadhar details efficiently. The whole process was smooth and hassle-free. Thank you!',
          location: 'Thane East'
        },
        {
          name: 'Vikram Singh',
          service: 'Railway Ticket Booking',
          rating: 5,
          text: 'Booked my tatkal tickets easily through them. They are quick and efficient. Saved me a lot of time and effort. Excellent service!',
          location: 'Dombivli'
        }
      ]
    },
    serviceRequest: {
      title: 'Request a Service',
      subtitle: 'Fill the form and we will contact you soon',
      name: 'Your Name',
      phone: 'Phone Number',
      service: 'Select Service',
      message: 'Additional Details (Optional)',
      submit: 'Submit Request',
      success: 'Thank you! We will contact you soon.',
      services: [
        'Aadhar Card Services',
        'PAN Card Services',
        'Driving License',
        'Passport Services',
        'Ration Card',
        'Vehicle Registration',
        'Railway Ticket Booking',
        'Income Tax Return',
        'PF Withdrawal',
        'Other Services'
      ]
    },
  },
  mr: {
    nav: {
      home: 'मुख्यपृष्ठ',
      services: 'सेवा',
      about: 'आमच्याबद्दल',
      contact: 'संपर्क',
      blogs: 'ब्लॉग'
    },
    hero: {
      title: 'आपले सरकार ई-सेवा केंद्र',
      subtitle: 'सर्व सरकारी आणि ऑनलाइन सेवांसाठी तुमचे एकच ठिकाण',
      description: 'आम्ही सरकारी फॉर्म, ऑनलाइन नोंदणी, दस्तऐवज सेवा आणि बरेच काही यासाठी संपूर्ण मदत प्रदान करतो. जलद, विश्वासार्ह आणि परवडणाऱ्या किंमतीत सेवा.',
      cta: 'सेवा पहा',
      cta2: 'संपर्क करा'
    },
    mainServices: {
      title: "लोकप्रिय सेवा श्रेणी",
      subtitle: "आमच्या सर्वाधिक मागणी असलेल्या दस्तऐवज सेवांमध्ये द्रुत प्रवेश",
      categories: [
        {
          id: 1,
          icon: "Briefcase",
          title: "व्यवसाय सुरू करण्यासाठी दस्तऐवज",
          gradient: "linear-gradient(135deg, rgb(208 216 249) 0%, rgb(118, 75, 162) 100%)",
          iconColor: "#667eea",
          items: [
            "शॉप ऍक्ट परवाना (गुमास्ता)",
            "उद्यम नोंदणी",
            "FSSAI परवाना",
            "भाडे करार नोंदणी",
            "मालकी व्यवसाय",
            "भागीदारी फर्म",
            "LLP फर्म",
            "खाजगी मर्यादित कंपनी"
          ]
        },
        {
          id: 2,
          icon: "TrendingUp",
          title: "व्यवसाय प्रचार दस्तऐवज",
          gradient: "linear-gradient(135deg, rgb(251 221 255) 0%, rgb(245, 87, 108) 100%)",
          iconColor: "#f5576c",
          items: [
            "ट्रेडमार्क नोंदणी",
            "वेबसाइट डिझाइन",
            "ISO प्रमाणपत्र"
          ]
        },
        {
          id: 3,
          icon: "GraduationCap",
          title: "शैक्षणिक दस्तऐवज",
          gradient: "linear-gradient(135deg, rgb(219 238 255) 0%, rgb(0 106 254) 100%)",
          iconColor: "#4facfe",
          items: [
            "अधिवास प्रमाणपत्र",
            "उत्पन्न प्रमाणपत्र"
          ]
        },
        {
          id: 4,
          icon: "FileText",
          title: "वैयक्तिक KYC दस्तऐवज",
          gradient: "linear-gradient(135deg, rgb(234 255 241) 0%, rgb(56, 249, 215) 100%)",
          iconColor: "#43e97b",
          items: [
            "पासपोर्ट",
            "ड्रायव्हिंग लायसन्स",
            "राजपत्र अधिसूचना",
            "MSEB नाव बदल",
            "वाहन विमा",
            "PAN कार्ड"
          ]
        }
      ]
    },
    services: {
      title: 'आमच्या संपूर्ण सेवा',
      subtitle: 'एकाच छताखाली सर्व सेवा',
      categories: [
        {
          name: 'ओळखपत्र आणि दस्तऐवज',
          icon: 'UserCheck',
          services: [
            'आधार कार्ड - अपडेट/सुधारणा',
            'पॅन कार्ड - नवीन अर्ज',
            'पॅन कार्ड - सुधारणा/रिप्रिंट',
            'रेशन कार्ड अर्ज',
            'मतदार ओळखपत्र',
            'पासपोर्ट अर्ज आणि नूतनीकरण',
            'उत्पन्न दाखला',
            'अधिवास दाखला',
            'जात दाखला'
          ]
        },
        {
          name: 'वाहन सेवा',
          icon: 'Car',
          services: [
            'शिकाऊ परवाना अर्ज',
            'ड्रायव्हिंग लायसन्स - नवीन',
            'ड्रायव्हिंग लायसन्स - नूतनीकरण',
            'आरसी ट्रान्सफर',
            'वाहन नोंदणी',
            'डुप्लिकेट आरसी',
            'वाहन NOC',
            'वाहन विमा',
            'प्रदूषण प्रमाणपत्र',
            'फिटनेस प्रमाणपत्र',
            'फॅन्सी नंबर अर्ज'
          ]
        },
        {
          name: 'प्रवास आणि बुकिंग',
          icon: 'Ticket',
          services: [
            'रेल्वे तिकीट बुकिंग (IRCTC)',
            'तत्काळ तिकीट बुकिंग',
            'विमान तिकीट बुकिंग',
            'बस तिकीट बुकिंग (MSRTC)',
            'हॉटेल बुकिंग',
            'ट्रॅव्हल इन्शुरन्स'
          ]
        },
        {
          name: 'सरकारी फॉर्म',
          icon: 'FileText',
          services: [
            'आयकर रिटर्न दाखल करणे',
            'GST नोंदणी',
            'GST रिटर्न दाखल करणे',
            'FSSAI परवाना',
            'शॉप ऍक्ट लायसन्स',
            'मालमत्ता कर भरणा',
            'वीज बिल भरणा',
            'पाणी बिल भरणा',
            'रेशन कार्ड फॉर्म',
            'ज्येष्ठ नागरिक कार्ड'
          ]
        },
        {
          name: 'रोजगार सेवा',
          icon: 'Briefcase',
          services: [
            'PF नोंदणी',
            'PF पैसे काढणे',
            'PF ट्रान्सफर',
            'ESI नोंदणी',
            'ESI दावा',
            'कामगार कार्ड नोंदणी',
            'बेरोजगारी भत्ता',
            'रोजगार नोंदणी',
            'रोजगार मेळावा नोंदणी'
          ]
        },
        {
          name: 'शिक्षण सेवा',
          icon: 'GraduationCap',
          services: [
            'शिष्यवृत्ती अर्ज',
            'शाळा प्रवेश फॉर्म',
            'महाविद्यालय प्रवेश फॉर्म',
            'परीक्षा फॉर्म भरणे',
            'शिक्षण कर्ज अर्ज',
            'प्रमाणपत्र पडताळणी',
            'स्थलांतर प्रमाणपत्र',
            'बोनाफाइड प्रमाणपत्र'
          ]
        },
        {
          name: 'मालमत्ता सेवा',
          icon: 'Home',
          services: [
            '७/१२ उतारा',
            '८अ उतारा',
            'मालमत्ता नोंदणी',
            'मालमत्ता कर',
            'म्युटेशन एंट्री',
            'मालमत्ता शोध',
            'जमीन रेकॉर्ड',
            'बांधकाम NOC'
          ]
        },
        {
          name: 'उपयोगिता आणि बिले',
          icon: 'Zap',
          services: [
            'वीज बिल भरणा',
            'MSEB नवीन कनेक्शन',
            'पाणी बिल भरणा',
            'गॅस बिल भरणा',
            'मोबाईल रिचार्ज',
            'DTH रिचार्ज',
            'ब्रॉडबँड बिल भरणा',
            'क्रेडिट कार्ड बिल भरणा',
            'विमा प्रिमियम भरणा'
          ]
        },
        {
          name: 'समाज कल्याण',
          icon: 'Heart',
          services: [
            'विधवा पेन्शन',
            'वृद्धापकाळ पेन्शन',
            'अपंगत्व पेन्शन',
            'अन्नपूर्णा योजना',
            'संजय गांधी निराधार योजना',
            'श्रावण बाल सेवा योजना',
            'अपंग प्रमाणपत्र',
            'विवाह नोंदणी प्रमाणपत्र'
          ]
        },
        {
          name: 'इतर सेवा',
          icon: 'Globe',
          services: [
            'ऑनलाइन फॉर्म भरणे',
            'झेरॉक्स आणि प्रिंटिंग',
            'स्कॅनिंग सेवा',
            'लॅमिनेशन',
            'पासपोर्ट साईज फोटो',
            'संगणक प्रशिक्षण',
            'डिजिटल स्वाक्षरी',
            'ईमेल आयडी निर्मिती',
            'रेझ्युमे तयार करणे',
            'नोटरी सेवा'
          ]
        }
      ]
    },
    why: {
      title: 'आम्हाला का निवडावे?',
      points: [
        {
          title: 'जलद आणि विश्वासार्ह सेवा',
          detail: 'आम्ही बहुतेक सेवा २४-४८ तासांत पूर्ण करतो. आमची कार्यक्षम प्रक्रिया अनावश्यक विलंब न करता तुमचे दस्तऐवज आणि सेवा मिळवून देते.'
        },
        {
          title: 'अनुभवी कर्मचारी',
          detail: 'आमच्या टीमला सरकारी दस्तऐवजीकरण आणि ऑनलाइन सेवांमध्ये १०+ वर्षांचा अनुभव आहे. आम्हाला प्रक्रिया चांगल्या प्रकारे माहित आहे आणि प्रत्येक टप्प्यावर मार्गदर्शन करतो.'
        },
        {
          title: 'परवडणारे दर',
          detail: 'कोणतेही लपलेले शुल्क नसलेले पारदर्शक आणि स्पर्धात्मक किंमती. गुणवत्तेशी तडजोड न करता प्रत्येकाला परवडणारे योग्य दर देण्यावर आमचा विश्वास आहे.'
        },
        {
          title: 'सर्व सेवा एकाच ठिकाणी',
          detail: 'आधार ते पासपोर्ट, पॅन ते वाहन नोंदणी - सर्व काही एकाच ठिकाणी करवा. आमच्या व्यापक सेवा श्रेणीसह वेळ आणि मेहनत वाचवा.'
        },
        {
          title: 'योग्य दस्तऐवज सहाय्य',
          detail: 'आवश्यक सर्व कागदपत्रे योग्यरित्या तयार करण्यात आम्ही मदत करतो. आमची चेकलिस्ट काहीही गहाळ नाही याची खात्री करते, नाकारणे टाळते आणि तुमचा मौल्यवान वेळ वाचवते.'
        },
        {
          title: 'ग्राहक गोपनीयता हमी',
          detail: 'आम्ही आपल्या दस्तऐवजांची गुप्तता आणि सुरक्षिततेची अत्यंत काळजी घेतो. संपूर्ण प्रक्रियेत आपल्या माहितीचे संरक्षण आणि गोपनीयता सुनिश्चित केली जाते. आपले दस्तऐवज सर्वतोपरी काळजीपूर्वक आणि गोपनीयपणे हाताळले जातात.'
        }
      ]
    },
    testimonials: {
      title: 'ग्राहकांचे अनुभव',
      subtitle: 'हजारो समाधानी ग्राहकांचा विश्वास',
      testimonials: [
        {
          name: 'राजेश कुमार',
          service: 'पॅन कार्ड सेवा',
          rating: 5,
          text: 'उत्कृष्ट सेवा! एका आठवड्यात माझे पॅन कार्ड मिळाले. कर्मचारी खूप मदतगार होते आणि संपूर्ण प्रक्रियेत मार्गदर्शन केले. अत्यंत शिफारसीय!',
          location: 'ठाणे पश्चिम'
        },
        {
          name: 'प्रिया शर्मा',
          service: 'पासपोर्ट अर्ज',
          rating: 5,
          text: 'अतिशय व्यावसायिक आणि कार्यक्षम. त्यांनी माझ्या पासपोर्ट अर्जात मदत केली आणि मला कोणत्याही अडचणीशिवाय मिळाले. उत्तम अनुभव!',
          location: 'कळवा'
        },
        {
          name: 'अमित पाटील',
          service: 'ड्रायव्हिंग लायसन्स',
          rating: 5,
          text: 'जलद आणि विश्वासार्ह सेवा. माझे ड्रायव्हिंग लायसन्स लवकर नूतनीकरण झाले. किंमत देखील खूप वाजवी होती. इतर सेवांसाठी नक्कीच परत येईन.',
          location: 'मुंब्रा'
        },
        {
          name: 'स्नेहा देसाई',
          service: 'आधार कार्ड अपडेट',
          rating: 5,
          text: 'खूप मदतगार कर्मचारी! त्यांनी माझे आधार तपशील कार्यक्षमतेने दुरुस्त केले. संपूर्ण प्रक्रिया सुलभ आणि अडचण मुक्त होती. धन्यवाद!',
          location: 'ठाणे पूर्व'
        },
        {
          name: 'विक्रम सिंग',
          service: 'रेल्वे तिकीट बुकिंग',
          rating: 5,
          text: 'त्यांच्याद्वारे माझी तत्काळ तिकिटे सहजपणे बुक केली. ते जलद आणि कार्यक्षम आहेत. माझा खूप वेळ आणि मेहनत वाचवली. उत्कृष्ट सेवा!',
          location: 'डोंबिवली'
        }
      ]
    },
    serviceRequest: {
      title: 'सेवा विनंती करा',
      subtitle: 'फॉर्म भरा आणि आम्ही लवकरच तुमच्याशी संपर्क साधू',
      name: 'तुमचे नाव',
      phone: 'फोन नंबर',
      service: 'सेवा निवडा',
      message: 'अतिरिक्त तपशील (पर्यायी)',
      submit: 'विनंती सबमिट करा',
      success: 'धन्यवाद! आम्ही लवकरच तुमच्याशी संपर्क साधू.',
      services: [
        'आधार कार्ड सेवा',
        'पॅन कार्ड सेवा',
        'ड्रायव्हिंग लायसन्स',
        'पासपोर्ट सेवा',
        'रेशन कार्ड',
        'वाहन नोंदणी',
        'रेल्वे तिकीट बुकिंग',
        'आयकर रिटर्न',
        'पीएफ पैसे काढणे',
        'इतर सेवा'
      ]
    },
  }
};